import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/Section";

const NotFound = () => (
  <React.Fragment>
    <Helmet>
      <title>Aspiricity - Page Not Found</title>
    </Helmet>
    <Header>
      <h1>Page Not Found</h1>
    </Header>
    <Section bgColor="bg-light" textColor="text-dark">
      <p className="lead">
        The page you're looking for may have moved, changed, or is no longer available.
      </p>
      <p>
        Return to the Aspiricity home page to continue exploring our consulting, training, and technical content.
      </p>
      <p>
        <Button as={Link} variant="primary" to="/">
          Return Home
        </Button>
      </p>
      <br />
    </Section>
    <Footer />
  </React.Fragment>
);

export default NotFound;
